export default function Gallery() {
  return <div></div>;
}
